import usePageMeta from '@/hooks/usePageMeta';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import InterviewHero from './components/InterviewHero';
import InterviewContent from './components/InterviewContent';

const InterviewPage = () => {
  usePageMeta({
    title: '社長インタビュー | 株式会社MSK',
    ogTitle: '社長インタビュー | 株式会社MSK',
    description: 'ITなびチャンネル「IT社長にアレコレ聞いてみた。」に出演しました。株式会社MSK社長インタビューをご覧ください。',
  });

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      <main>
        <InterviewHero />
        <InterviewContent />
      </main>
      <Footer />
    </div>
  );
};

export default InterviewPage;